// extracted by mini-css-extract-plugin
module.exports = {"container":"LangToggle_container__296n9","containerNotAuth":"LangToggle_containerNotAuth__2z3-f"};